import app_config from 'config/app_config'
import { IInvoicesReadyToPay } from 'redux/invoices/types'

import apiMiddleware from './api_middleware'

// The server-driven "everything this company can bulk-pay" set. The intents bulk flow calls
// it directly (not through redux) so the two bulk buttons never react to each other's clicks.
export const fetchInvoicesReadyToPay = async (): Promise<IInvoicesReadyToPay> =>
	apiMiddleware({
		url: app_config.services.getInvoicesReadyToPay,
		method: 'POST',
	})
